/** @format */
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { stripHtml } from "string-strip-html";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://lkwb.com.np";

const SEO = ({ title = "", description = "", image = "", keywords = "" }) => {
  const location = useLocation(); // get current frontend route
  const siteInfo = useSelector((state) => state.home?.siteInfo);
  const seoData = siteInfo?.seo_data;

  if (!seoData && !title && !description && !keywords) return null;

  const truncate = (text, maxLength = 155) => {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    const truncated = text.substring(0, maxLength);
    return truncated.substring(0, truncated.lastIndexOf(" ")) || truncated;
  };

  const metaTitle = (
    title ||
    seoData?.meta_title ||
    "LWKB – Learn English"
  ).trim();
  const rawDescription = description || seoData?.meta_description || "";
  const metaDescription = truncate(stripHtml(rawDescription).result, 155);

  // Keywords
  let metaKeywords = "";
  if (Array.isArray(keywords) && keywords.length > 0)
    metaKeywords = keywords.join(", ");
  else if (typeof keywords === "string" && keywords) metaKeywords = keywords;
  else if (seoData?.meta_keywords)
    metaKeywords =
      Array.isArray(seoData.meta_keywords) ?
        seoData.meta_keywords.join(", ")
      : seoData.meta_keywords;

  // Canonical: automatically detect current route
  const canonicalUrl = `${BASE_URL}${location.pathname}`;

  const metaImage =
    image || seoData?.meta_image || `${BASE_URL}/default-og-image.jpg`;

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{metaTitle}</title>
      {metaDescription && <meta name="description" content={metaDescription} />}
      {metaKeywords && <meta name="keywords" content={metaKeywords} />}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={metaImage} />
      <meta property="og:url" content={canonicalUrl} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
    </Helmet>
  );
};

export default SEO;
